import jQuery from  'jquery';
import moment from "moment-timezone";
import { 
    Market, 
    OddsFormat, 
    BetTypeGroup, 
    BetType, 
    SportGroup, 
    Product, 
    TooltipActions, 
    PERIODS_DESC, 
    TennisGradingUnit, 
    RunningStateExtraTime
} from './Foundation';
import CommonUtil from './CommonUtil';

// ----------------------------------------------------------------------- //
// This extensions only use for doT template to render oddspage.
// ----------------------------------------------------------------------- //
window.Market = Market;
window.OddsFormat = OddsFormat;
window.BetTypeGroup = BetTypeGroup;
window.BetType = BetType;
window.SportGroup = SportGroup;
window.Product = Product;
window.TooltipActions = TooltipActions;
window.PERIODS_DESC = PERIODS_DESC;
window.TennisGradingUnit = TennisGradingUnit;
window.RunningStateExtraTime = RunningStateExtraTime;
window.getPeriodsName = CommonUtil.getPeriodName;
window.getEventSetsId = CommonUtil.getEventSetsId;
window.getMoreBetTeamTotal = CommonUtil.getMoreBetTeamTotal;
window.getPeriodMoreBet = CommonUtil.getPeriodMoreBet;
window.fetchParentId = CommonUtil.fetchParentId;
window.findEventParentMoreBet = CommonUtil.findEventParentMoreBet;
window.getTypeEventTennis = CommonUtil.getTypeEventTennis;
window.fetchOddsByPeriods = CommonUtil.fetchOddsByPeriods;
window.countMoreBetSingleLine = CommonUtil.countMoreBetSingleLine;
window.countRowSpanMoreBet = CommonUtil.countRowSpanMoreBet;
window.getRedCard = CommonUtil.getRedCard;
window.changedOddsWS = {};

(function($) {
    function DateTZ(dateString) {
        if (arguments.length === 1) {
            if (typeof arguments[0] === 'number') {
                var mil = arguments[0] - (DateTZ.localTimeZone - DateTZ.defaultTZOffset) * 60000;
                return new Date(mil);
            } else {
                return new Date(dateString);
            }
        } else if (arguments.length === 0) {
            return new Date();
        }
        return new Date(arguments[0] || 0, arguments[1] || 0, arguments[2] || 0, arguments[3] || 0, arguments[4] || 0, arguments[5] || 0, arguments[6] || 0);
    }
    DateTZ.localTimeZone = -(new Date().getTimezoneOffset());
    DateTZ.defaultTZOffset = DateTZ.localTimeZone;
    window.DateTZ = DateTZ;

    Array.prototype.init = function(length, startValue) {
        for (var i = 0; i < length; i++) {
            this[i] = startValue === undefined ? i : startValue++;
        }
        return this;
    };

    SportGroup.stringOf = function (value) {
        for (var name in this) {
            if (value === this[name]) {
                return name;
            }
        }
    };

    String.prototype.replaceAll = function (target, replacement) {
        return this.split(target).join(replacement);
    };

    String.prototype.formatSeparators = function () {
        var inD = ".", outD = ".", sep = ",";
        var result = this;    
        result += '';
        var dpos = result.lastIndexOf(inD);
        var nStrEnd = '';
        if (dpos !== -1) {
                nStrEnd = outD + result.substring(dpos + 1, result.length);
                result = result.substring(0, dpos);
        }
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(result)) {
                result = result.replace(rgx, '$1' + sep + '$2');
        }
        return result + nStrEnd;    
    };

    String.prototype.format = function () {
      var a = this;
      for (var k in arguments) {
          a = a.replace(new RegExp("\\{" + k + "\\}", 'g'), arguments[k]);
      }
      return a
    };
    Number.prototype.formatSeparators = function () {
        var inD = ".", outD = ".", sep = ",";;
        var result = this;    
        result += '';
        var dpos = result.lastIndexOf(inD);
        var nStrEnd = '';
        if (dpos !== -1) {
                nStrEnd = outD + result.substring(dpos + 1, result.length);
                result = result.substring(0, dpos);
        }
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(result)) {
                result = result.replace(rgx, '$1' + sep + '$2');
        }
        return result + nStrEnd;    
    };

    String.prototype.trimStart = function(tail) {
        var result = this;
        while (result.substring(0, tail.length) == tail)
            result = result.substring(tail.length);
        return result.toString();
    };
    
    Number.prototype.toDollar = function(digits, lengthy) {
        var i,
                result = lengthy ? this.toFixed(digits) : this.toFlex(digits),
                minus = result.startsWith("-");
        if (minus) {
            result = result.trimStart("-");
        }

        digits = digits || 0;

        var buffer = [];

        // get the index or '.', if not found, start from the last didigt
        var last = result.lastIndexOf('.');

        if (last < 0) {
            last = result.length - 1;
        } else {// right now assume 2 digits only, no care is take for the decimals
            last -= 1;
            for (i = result.length - 1; i > last; i--) {
                buffer.push(result.charAt(i));
            }
        }
        var sep = ",";
        for (i = last; i >= 0; i--) {
            var count = last - i;
            if (count > 0 && count % 3 == 0) {
                buffer.push(sep);
            }
            buffer.push(result.charAt(i));
        }
        if (minus) {
            buffer.push("-");
        }
        return buffer.reverse().join('').toString().formatSeparators();
    };

    Number.prototype.toFixedNoRounding = function(n) {
      if(n) {
        const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g")
        const a = this.toString().match(reg)[0];
        const dot = a.indexOf(".");
        if (dot === -1) { // integer, insert decimal dot and pad up zeros
            return a + "." + "0".repeat(n);
        }
        const b = n - (a.length - dot) + 1;
        return b > 0 ? (a + "0".repeat(b)) : a;
      }
      return 0;
   }

    Number.prototype._toFixed = Number.prototype.toFixed;
    /**
     * Overide to ensure same output in IE and other browser
     */
    Number.prototype.toFixed = function(digits) {
        return Math.round(this, digits)._toFixed(digits);
    };
    
    Array.prototype.removeAll = function(items) {
        var newItems = [];
        for (var i = 0; i < this.length; i++) {
            if ($.inArray(this[i], items) === -1) {
                newItems.push(this[i]);
            }
        }
        return newItems;
    };

    Array.prototype.addAll = function(item) {
        return this.concat(item);
    };
    Math._round = Math.round;
    Math.round = function(number, bits) {
        if (bits < 0)
            return number;
        bits = bits || 0; // default round 0 decimal
        var dir = number > 0 ? 1 : -1;
        var i = Math.pow(10, bits);
        number = Math.abs(number) + 1 / Math.pow(10, bits + 5);
        return Math._round(number * i) / i * dir;
    };

    window.moment = function(dateString) {
        return moment(dateString);
    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/app/common/Extensions.js